import styled from "styled-components";

export const Container = styled.div<{ $minimized?: boolean, $isOpenMenu?: boolean }>`
    position: absolute;
    bottom: 5px;
    /* left: 107px; */
    left: ${({ $isOpenMenu }) => ($isOpenMenu ? "545px" : "107px")};
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 100;
    min-width: ${({ $minimized }) => ($minimized ? "auto" : "200px")};
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;

export const Title = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        font-size: 16px;
        color: #64748b;
    }
`;

export const ToggleButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: #64748b;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 18px;
    }

    &:hover {
        background: #f1f5f9;
        color: #2196f3;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const legendColorVariants = {
    blue: "#0078ff",
    gray: "#94a3b8",
    green: "#009157",
    yellow: "#fbbf24",
} as const;

export const LegendColor = styled.div<{
    $variant: keyof typeof legendColorVariants;
    $selected?: boolean;
}>`
    width: 14px;
    height: 14px;
    border-radius: 3px;
    flex-shrink: 0;
    background: ${({ $variant }) => legendColorVariants[$variant]};
    border: 2px solid ${({ $variant }) =>
        $variant === "blue" ? "#FF0000" : "transparent"};
    box-sizing: border-box;
`;

export const LegendInfo = styled.div`
    flex: 1;
`;

export const LegendLabel = styled.div`
    font-size: 11px;
    color: #1e293b;
    margin-bottom: 2px;
`;